<div class="add-project-dialog-container">
  <!-- Modal Header -->
  <div class="modal-header">
    <h2 class="modal-title">{{ data.title }}</h2>
    @if (data.hasClose) {
      <button
        mat-icon-button
        class="close-button"
        [mat-dialog-close]="false"
        aria-label="Close"
      >
        <mat-icon>close</mat-icon>
      </button>
    }
  </div>

  <!-- Modal Content -->
  <div class="modal-content">
    <form
      [formGroup]="projectForm"
      (ngSubmit)="submitForm(projectForm, projectForm.valid, $event)"
    >
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Project Name</mat-label>
        <input
          matInput
          placeholder="Enter project name"
          formControlName="name"
          required
        />
        @if (projectForm.get("name")?.hasError("required")) {
          <mat-error> Project name is required </mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Project Description</mat-label>
        <input
          matInput
          placeholder="Enter project description"
          formControlName="description"
          required
        />
        @if (projectForm.get("description")?.hasError("required")) {
          <mat-error> Project description is required </mat-error>
        }
      </mat-form-field>

      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Workflow Name</mat-label>
        <input
          matInput
          placeholder="Enter workflow name"
          formControlName="workflowName"
          required
        />
        @if (projectForm.get("workflowName")?.hasError("required")) {
          <mat-error> Workflow name is required </mat-error>
        }
      </mat-form-field>

      <div class="features-section">
        <h4 class="features-title">Available Features</h4>
        <mat-selection-list
          #featureList
          (selectionChange)="onFeatureSelectionChange($event)"
        >
          @for (feature of features(); track feature.featureId) {
            <mat-list-option
              [value]="feature.featureId"
              checkboxPosition="before"
            >
              {{ feature.displayName }}
            </mat-list-option>
          }
        </mat-selection-list>
      </div>
    </form>
  </div>

  <!-- Modal Actions -->
  <div class="modal-actions">
    <button class="cancel-button" [mat-dialog-close]="false">Cancel</button>
    <button
      class="create-button"
      (click)="submitForm(projectForm, projectForm.valid, $event)"
      [disabled]="projectForm.invalid"
    >
      Create Project
    </button>
  </div>
</div>
